import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["fa", "en", "ar"],
  defaultLocale: "fa",
  // fa stays at bare paths (no /fa prefix) → zero ranking loss; en/ar are prefixed.
  localePrefix: "as-needed",
  // Off on purpose: Googlebot's en-US Accept-Language would otherwise 301 the
  // canonical "/" homepage to "/en" and de-index the fa homepage.
  localeDetection: false,
});
